export default {"src":"/_next/static/media/seamless-eco-system-integration.1d401095.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};